/* ----------------------------------------------------------------------------------------
   Función extraida de Shopify para formatear una moneda
---------------------------------------------------------------------------------------- */
var Shopify = Shopify || {}
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}'
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || this.money_format

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    )
    const cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}



/* ----------------------------------------------------------------------------------------
   Función para trabajar el API de Google maps
---------------------------------------------------------------------------------------- */
function _initCustomMap() {
  //const google = google || {}
  const bounds = new google.maps.LatLngBounds()

  const mapTarget = document.getElementById('map')
  const $data = JSON.parse(mapTarget.dataset.markers.toString())
  const icons = JSON.parse(mapTarget.dataset.settings.toString())

  const streets = []
  const locations = []
  const store = []
  const storeUrl = []
  const id = []

  let count = 0
  $data.forEach((data) => {
    count++
    streets[count] = data.street
    locations[count] = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) }
    store[count] = data.store
    storeUrl[count] = data.url_store
    id[count] = count
  })

  const mapCustom = new google.maps.Map(mapTarget, {
    mapId: 'e846a7b3ebe74fde',
    zoom: 4,
    minZoom: 4,
    maxZoom: 15,
    gestureHandling: 'cooperative',
    disableDefaultUI: true,
    clickableIcons: true
  })

  const infoWindow = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: false
  })

  const markers = streets.map((street, i) => {
    const icon = {
      url: icons.icon,
      scaledSize: new google.maps.Size(35, 35),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 35)
    }

    const iconHover = {
      url: icons.icon_hover,
      scaledSize: new google.maps.Size(35, 35),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 35)
    }

    const datalistOption = document.querySelectorAll('#street_list option')
    const location = locations[i]

    mapCustom.setCenter(location)
    const marker = new google.maps.Marker({
      map: mapCustom,
      position: location,
      street,
      icon,
      optimized: false
    })

    /*-----LEEMOS EL JSON--------*
    mapCustom.data.loadGeoJson('stores.json', {idPropertyName: 'storeid'});

    /* Show the information for a store when its marker is clicked.
    map.data.addListener('click', (event) => {
      const category = event.feature.getProperty('category');
      const name = event.feature.getProperty('name');
      const description = event.feature.getProperty('description');
      const hours = event.feature.getProperty('hours');
      const phone = event.feature.getProperty('phone');
      const position = event.feature.getGeometry().get();
      const content = `
        <h2>${name}</h2><p>${description}</p>
        <p><b>Open:</b> ${hours}<br/><b>Phone:</b> ${phone}</p>
      `;

      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
      infoWindow.open(map);
    });
    */
    bounds.extend(location)
    const url = 'http://maps.google.com/?q=' + encodeURIComponent(street)

    const content =
      '<div class="container_content__icon-map">' +
      '<div class="container__icon-map">' +
      '<h2 class="title__icon-map">' +
      store[i] +
      '</h2>' +
      '<a href="https://' +
      storeUrl[i] +
      '" rel="nofollow noopener noreferrer" class="button__icon-map" target="_blank">' +
      storeUrl[i] +
      '</a>' +
      '<hr/>' +
      '<p class="street__icon-map">' +
      street +
      '</p>' +
      '<a href="' +
      url +
      '" rel="nofollow noopener noreferrer" class="button__icon-map" target="_blank">Ver en Google Maps</a>' +
      '</div>' +
      '</div>'

    google.maps.event.addDomListener(datalistOption[i - 1], 'click', () => {
      infoWindow.setContent(content)
      infoWindow.open(mapCustom, marker)
      mapCustom.panTo(marker.getPosition())
    })

    marker.addListener('click', () => {
      infoWindow.setContent(content)
      infoWindow.open(mapCustom, marker)
    })

    marker.addListener('mouseover', () => {
      marker.setIcon(iconHover)
      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1)
    })

    marker.addListener('mouseout', () => {
      marker.setIcon(icon)
      marker.setZIndex(1)
    })

    const elementId = "[id='" + id[i] + "']"
    const $element = document.querySelectorAll(elementId)

    if ($element.length !== 0) {
      const $id = $element[0]
      const $elementLink = $id.querySelectorAll('a')

      $id.addEventListener('click', () => {
        infoWindow.setContent(content)
        infoWindow.open(map, marker)
        if (window.innerWidth < 981) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })

      $elementLink.forEach((link) => {
        link.addEventListener(
          'click',
          function () {
            event.stopPropagation()
          },
          false
        )
      })

      $id.addEventListener('mouseover', () => {
        if (window.innerWidth > 981) {
          marker.setIcon(iconHover)
          marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1)
          infoWindow.setContent(content)
          infoWindow.open(map, marker)
        }
      })

      $id.addEventListener('mouseout', () => {
        if (window.innerWidth > 981) {
          marker.setIcon(icon)
          marker.setZIndex(1)
          // infoWindow.close();
        }
      })
    }

    marker.setMap(mapCustom)
    return marker
  })

  const _initialZoom = function () {
    this.setZoom(4)
    google.maps.event.clearListeners(mapCustom, 'bounds_changed')
  }
  google.maps.event.addListener(
    mapCustom,
    'bounds_changed',
    _initialZoom,
    false
  )
  mapCustom.fitBounds(bounds)
}

// Clase para configurar el buscador de Google maps
class DataList {
  constructor(inputId) {
    this.inputId = inputId
  }

  addListeners(datalist) {
    const container = document.getElementsByTagName('body')[0]
    const input = document.getElementById(this.inputId)
    const listId = input.dataset.list
    const listOptions = '#' + listId + ' option'
    const options = document.querySelectorAll(listOptions)
    const list = document.getElementById(listId)

    container.addEventListener('click', (e) => {
      if (e.target.id === this.inputId) {
        container.classList.add('datalist')
      } else {
        container.classList.remove('datalist')
      }
    })

    input.addEventListener('input', () => {
      if (!container.classList.contains('datalist')) {
        container.classList.add('datalist')
      }
      let valueNeedle
      let arrayText
      for (const option of options) {
        const optionText = normalizeString(option.innerText.toLowerCase())
        valueNeedle = normalizeString(input.value.toLowerCase())
        arrayText = arrayText + optionText + '-'

        if (valueNeedle !== '-') {
          if (optionText.includes(valueNeedle)) {
            option.style.display = ''
          } else {
            option.style.display = 'none'
          }
        }
      }

      if (valueNeedle !== ' ' && arrayText.includes(valueNeedle)) {
        options[0].parentNode.style.display = ''
      } else {
        options[0].parentNode.style.display = 'none'
      }
    })

    input.addEventListener('click', () => {
      if (!container.classList.contains('datalist')) {
        container.classList.add('datalist')
      }
      let valueNeedle
      let arrayText
      for (const option of options) {
        const optionText = normalizeString(option.innerText.toLowerCase())
        valueNeedle = normalizeString(input.value.toLowerCase())
        arrayText = arrayText + optionText + '-'

        if (valueNeedle !== '-') {
          if (optionText.includes(valueNeedle)) {
            option.style.display = ''
          } else {
            option.style.display = 'none'
          }
        }
      }

      if (valueNeedle !== ' ' && arrayText.includes(valueNeedle)) {
        options[0].parentNode.style.display = ''
      } else {
        options[0].parentNode.style.display = 'none'
      }
    })

    input.addEventListener('focus', () => {
      list.scrollTo(0, 0)
    })

    list.addEventListener('click', (e) => {
      if (e.target.nodeName.toLocaleLowerCase() === 'option') {
        // input.value = e.target.innerText;
        input.value = ''
        container.classList.remove('datalist')
      }
    })
  }
}

// Función para eliminar tildes y simbolos raros de los string
const normalizeString = (function () {
  const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç'
  const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc'
  const mapping = {}

  for (let i = 0, j = from.length; i < j; i++) {
    mapping[from.charAt(i)] = to.charAt(i)
  }

  return function (str) {
    const ret = []
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i)
      if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c])
      else ret.push(c)
    }
    return ret.join('')
  }
})()

// Añadir API Google maps
const mapActive = document.querySelectorAll('#map')
if (mapActive.length !== 0) {
  const data = JSON.parse(mapActive[0].dataset.settings.toString())
  const apiMaps = document.createElement('script')
  apiMaps.setAttribute('id', 'google_map_api')
  apiMaps.setAttribute(
    'src',
    'https://maps.googleapis.com/maps/api/js?key=' +
    data['key'] +
    '&callback=_initCustomMap'
  )
  apiMaps.setAttribute('type', 'text/javascript')
  const head = document.querySelector('head')
  head.appendChild(apiMaps)

  //Añadir funcionalidad del buscador
  const datalist = new DataList('street')
  datalist.addListeners(datalist)
}

/* ----------------------------------------------------------------------------------------
   Función para funcionar flechas de sliders y carrousel
---------------------------------------------------------------------------------------- */

const scrollCheak = (container, buttonLeft, buttonRight) => {
  if (
    !(
      container.firstElementChild == null ||
      container.firstElementChild == 'undefined' ||
      container.firstElementChild == ''
    )
  ) {
    if (container.scrollWidth > container.offsetWidth) {
      buttonLeft.classList.remove("hide")
      buttonRight.classList.remove("hide")
    }
    const scrollStart =
      container.scrollLeft - container.firstElementChild.offsetWidth * 0.5
    const scrollEnd =
      container.scrollWidth -
      container.lastElementChild.offsetWidth * 0.5 -
      (container.scrollLeft + container.offsetWidth)
    const disabled = 'disabled'
    if (scrollStart <= 0) {
      buttonLeft.classList.add(disabled)
      buttonRight.classList.remove(disabled)
    } else if (scrollEnd <= 0) {
      buttonRight.classList.add(disabled)
      buttonLeft.classList.remove(disabled)
    } else {
      buttonLeft.classList.remove(disabled)
      buttonRight.classList.remove(disabled)
    }
  }
}

const slideScroll = (element, container) => {
  const direction = element.dataset.direction
  const style = window.getComputedStyle(container)
  const gap = parseInt(style.getPropertyValue('--gap'))
  let scrollMove = container.firstElementChild.offsetWidth + gap;

  /*   container.childNodes.forEach((child) => console.log({ child, width: child.offsetWidth }));
   */
  console.log({ scrollMove, gap, firstchildWidth: container.firstElementChild.offsetWidth })

  if (direction === 'start') {
    scrollMove = container.firstElementChild.offsetWidth * -1
  }
  container.scrollLeft += scrollMove
}

const moveCarrouselActive = (event, carrousel) => {
  event.preventDefault()
  let firstPosition = event.pageX
  let move = 0
  let start = false
  const time = event.timeStamp
  let isMove = setTimeout(function () {
    carrousel.removeEventListener('mousemove', _moveCarrousel, false)
  }, 200)

  const _moveCarrousel = (event) => {
    window.clearTimeout(isMove)
    move = firstPosition - event.pageX
    firstPosition = event.pageX
    carrousel.scrollLeft += move
    carrousel.classList.add('drag')

    if (start == false) {
      start = true
      carrousel.addEventListener('mouseleave', _leaveCarrousel, false)
      carrousel.addEventListener('mouseup', _leaveCarrousel, false)
    }
  }

  const _leaveCarrousel = (event) => {
    event.preventDefault()
    carrousel.removeEventListener('mousemove', _moveCarrousel, false)
    carrousel.classList.add('dragEnd')
    carrousel.classList.remove('drag')
    const childWidth = carrousel.querySelector('div').offsetWidth
    const position = Math.round(carrousel.scrollLeft / childWidth)
    const style = window.getComputedStyle(carrousel)
    let gap = style.getPropertyValue('--gap')
    if (gap == '') {
      gap = 0
    } else {
      gap = parseInt(gap)
    }
    let finalPosition
    const timeCondition = time + 300 > event.timeStamp
    if (timeCondition && move > 0) {
      finalPosition =
        position * childWidth + position * gap + (childWidth + gap)
    } else if (timeCondition && move < 0) {
      finalPosition =
        position * childWidth + position * gap - (childWidth + gap)
    } else {
      finalPosition = position * childWidth + position * gap
    }
    carrousel.scrollLeft = finalPosition
    carrousel.removeEventListener('mouseleave', _leaveCarrousel, false)
    carrousel.removeEventListener('mouseup', _leaveCarrousel, false)
    start = false
  }

  carrousel.addEventListener('mousemove', _moveCarrousel, false)
}

setTimeout(function () {
  const carrousel = document.querySelectorAll('.container_ccu-carrousel.active')
  carrousel.forEach((element) => {
    const arrows = element.querySelector('.arrows_ui')
    const buttonLeft = arrows.querySelector('.left-arrow')
    const buttonRight = arrows.querySelector('.right-arrow')
    const carrousel = element.querySelector('.box_ccu-carrousel')
    scrollCheak(carrousel, buttonLeft, buttonRight)
    carrousel.addEventListener(
      'scroll',
      function () {
        scrollCheak(carrousel, buttonLeft, buttonRight)
      },
      false
    )
    carrousel.addEventListener(
      'mousedown',
      function (event) {
        moveCarrouselActive(event, carrousel)
      },
      false
    )

    let isScrolling
    carrousel.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(isScrolling)
        isScrolling = setTimeout(function () {
          carrousel.classList.remove('dragEnd')
        }, 66)
      },
      false
    )

    buttonLeft.addEventListener(
      'click',
      function () {
        slideScroll(buttonLeft, carrousel)
      },
      false
    )
    buttonRight.addEventListener(
      'click',
      function () {
        slideScroll(buttonRight, carrousel)
      },
      false
    )
  })

  const carrouselInsta = document.querySelectorAll('#containerFeed')
  carrouselInsta.forEach((element) => {
    const arrows = element.querySelector('.arrows_ui')
    const buttonLeft = arrows.querySelector('.left-arrow')
    const buttonRight = arrows.querySelector('.right-arrow')
    buttonLeft.addEventListener(
      'click',
      function () {
        slideScroll(buttonLeft, element.querySelector('.sw-instagram-row'))
      },
      false
    )
    buttonRight.addEventListener(
      'click',
      function () {
        slideScroll(buttonRight, element.querySelector('.sw-instagram-row'))
      },
      false
    )
    scrollCheak(
      element.querySelector('.sw-instagram-row'),
      buttonLeft,
      buttonRight
    )
    element.querySelector('.sw-instagram-row').addEventListener(
      'scroll',
      function () {
        scrollCheak(
          element.querySelector('.sw-instagram-row'),
          buttonLeft,
          buttonRight
        )
      },
      false
    )

    element.querySelector('.sw-instagram-row').addEventListener(
      'mousedown',
      function (event) {
        moveCarrouselActive(event, element.querySelector('.sw-instagram-row'))
      },
      false
    )

    let isScrolling
    element.querySelector('.sw-instagram-row').addEventListener(
      'scroll',
      function () {
        window.clearTimeout(isScrolling)
        isScrolling = setTimeout(function () {
          element.querySelector('.sw-instagram-row').classList.remove('dragEnd')
        }, 66)
      },
      false
    )
  })
}, 2000)

const slideshow = document.querySelectorAll('.slideshow')
slideshow.forEach((element) => {
  element.addEventListener(
    'mousedown',
    function (event) {
      moveCarrouselActive(event, element)
    },
    false
  )
  let isScrolling
  element.addEventListener(
    'scroll',
    function () {
      window.clearTimeout(isScrolling)
      isScrolling = setTimeout(function () {
        element.classList.remove('dragEnd')
      }, 66)
    },
    false
  )
})

/* ----------------------------------------------------------------------------------------
   Función para cambiar de carrousel
---------------------------------------------------------------------------------------- */
const buttons = document.querySelectorAll('.custom-carrousel__buttons button')
buttons.forEach((button) => {
  button.addEventListener(
    'click',
    function () {
      const target = button.dataset.target
      const carrousel = document.getElementById(target)
      carrousel
        .closest('.custom-carrousel__content')
        .querySelector('.active')
        .classList.remove('active')
      button
        .closest('.custom-carrousel__buttons')
        .querySelector('.active')
        .classList.remove('active')
      console.log()
      carrousel.classList.add('active')
      button.classList.add('active')
    },
    false
  )
})

/* ----------------------------------------------------------------------------------------
   Función para abrir desplegables del footer
---------------------------------------------------------------------------------------- */
const footerDesplegable = document.querySelectorAll('.footer-block--menu')
footerDesplegable.forEach((element) => {
  element.querySelector('.footer-block__heading').addEventListener(
    'click',
    () => {
      const list = element.querySelector('.footer-block__details-content')
      if (element.classList.contains('open')) {
        element.classList.remove('open')
        list.style.height = ''
      } else {
        element.classList.add('open')
        list.style.height = list.scrollHeight + 'px'
      }
    },
    false
  )
})

/* ----------------------------------------------------------------------------------------
   Función para detectar si un elemento es visible en la ventan
---------------------------------------------------------------------------------------- */
const isInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  const height = element.offsetHeight

  return (
    rect.top >= height * -1 &&
    rect.bottom <=
    (window.innerHeight + height ||
      document.documentElement.clientHeight + height)
  )
}

/* ----------------------------------------------------------------------------------------
   Funciones para animar la section -- infinite-slide -- y el snippet -- infinite-slide-item:
---------------------------------------------------------------------------------------- */
const infiniteSlideStart = ($element, $callback) => {
  if (isInViewport($element)) {
    $element.style.setProperty('--animationName', 'animationSlide')
    $element.style.setProperty(
      '--animationDuration',
      $element.dataset.duration * 2 + 's'
    )
    $element.style.setProperty('--animationState', 'running')
    document.removeEventListener('scroll', $callback, false)
    document.addEventListener(
      'scroll',
      function () {
        const state = $element.style.getPropertyValue('--animationState')
        const inViewport = isInViewport($element)
        if (inViewport && state === 'paused') {
          $element.style.setProperty('--animationState', 'running')
        } else if (!inViewport && state === 'running') {
          $element.style.setProperty('--animationState', 'paused')
        }
      },
      false
    )
  }
}

// Evento para lanzar la animación del infinite-slide_slideshow-animation y infinite-slide-item
const infiniteSlide = document.querySelectorAll('.infinite_slide__container')
infiniteSlide.forEach((element) => {
  const _function = () => {
    infiniteSlideStart(element, _function)
  }
  document.addEventListener('scroll', _function, false)
  infiniteSlideStart(element, _function)
})

/* ----------------------------------------------------------------------------------------
   Funciones para generar los dots de la galería de imágenes
---------------------------------------------------------------------------------------- */

const gallery = document.querySelectorAll('.product__media-list')
gallery.forEach((element) => {
  const children = element.querySelectorAll('li')
  const dotContainer = document.querySelector('.container-dot')
  children.forEach(() => {
    const dot = document.createElement('span')
    dot.classList.add('dot')
    dotContainer.appendChild(dot)
  })
  const width = element.offsetWidth
  const scrollPosition = element.scrollLeft
  const position = Math.round(scrollPosition / width)
  dotContainer.querySelectorAll('span')[position].classList.add('active')
  element.addEventListener(
    'scroll',
    function () {
      scrollCheackDot(element, dotContainer)
    },
    false
  )
})

const scrollCheackDot = (gallery, dotContainer) => {
  const width = gallery.offsetWidth
  const scrollPosition = gallery.scrollLeft
  const position = Math.round(scrollPosition / width)
  dotContainer.querySelector('.active').classList.remove('active')
  dotContainer.querySelectorAll('span')[position].classList.add('active')
}

/* ----------------------------------------------------------------------------------------
   Funcion para cambiar el grid de la página de collection
---------------------------------------------------------------------------------------- */
const changeGrid = document.querySelectorAll('.button_change_grid')
changeGrid.forEach((element) => {
  element.addEventListener(
    'change',
    function () {
      const grid = document.querySelector('#product-grid')
      grid.dataset.grid = element.value
    },
    false
  )
})

/* ----------------------------------------------------------------------------------------
   Funcion para añadir las tendencias
---------------------------------------------------------------------------------------- */

const impulso = (impulso) => {
  const searchInput = document.querySelector(
    'header .search-modal__form .search__input'
  )
  searchInput.value = impulso
  searchInput.focus()
}

/* ----------------------------------------------------------------------------------------
   Funcion para ocultar o mostrar los filtros en escritori
---------------------------------------------------------------------------------------- */
const buttonFilter = () => {
  const button = document.querySelector('#hideFilter')
  const textReveal = button.querySelector('span.revealf')
  const textHide = button.querySelector('span.hidef')
  const filter = document.querySelector('.facets-wrapper')
  filter.classList.toggle('close')

  if (filter.classList.contains('close')) {
    textReveal.classList.add('hidden')
    textHide.classList.remove('hidden')
  } else {
    textReveal.classList.remove('hidden')
    textHide.classList.add('hidden')
  }
}

/*----------------------------------------------------------------------------------------
   Función para cargar el video de youtube
----------------------------------------------------------------------------------------*/
const videoHome = document.querySelectorAll('.vh__video-box.vh__video-youtube')
if (videoHome.length != 0) {
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  let player
}
function onYouTubeIframeAPIReady() {
  videoHome.forEach((element) => {
    const videoBox = element.querySelector('.vh__video')
    const videoUrl = videoBox.dataset.desktop
    player = new YT.Player('id-' + videoUrl, {
      height: '100%',
      width: '100%',
      videoId: videoUrl,
      playerVars: {
        autoplay: 1,
        controls: 0,
        modestbranding: 1,
        loop: 1,
        autohide: 0,
        mute: 1,
        playsinline: 1,
        origin: window.location.hostname
      },
      events: {
        onReady: onReady,
        onStateChange: onStateChange
      }
    })
  })
}

function onReady(event) {
  event.target.mute()
  event.target.playVideo()
}

function onStateChange(event) {
  if (event.data == 1) {
    event.target.mute()
    document.querySelector('#img' + event.target.h.g.videoId).style.display = 'none'
    // document.querySelector('#info' + event.target.h.g.videoId).style.display = 'none'
  }

  if (event.data == 0 || event.data == 2 || event.data == -1) {
    event.target.playVideo()
  }
}

const passRevealitems = document.querySelectorAll('.pass-reveal')
passRevealitems.forEach((passReveal) => {
  passReveal.addEventListener(
    'click',
    function () {
      const input = passReveal.parentElement.querySelector('input')
      if (input.getAttribute('type') == 'password') {
        passReveal.classList.add('text')
        input.setAttribute('type', 'text')
      } else {
        input.setAttribute('type', 'password')
        passReveal.classList.remove('text')
      }
    },
    false
  )
})

// /*------------------------------------------------------------------------*/

// const containers = document.querySelectorAll('.vh__container');

// const handleScroll = () => {
//   const shouldHideOverflow = window.scrollY >= 1;

//   containers.forEach((container) => {
//     container.style.pointerEvents = shouldHideOverflow ? 'none' : '';
//   });
// };
// const video_container =
//   document.querySelector(".vh__container")
// video_container.addEventListener("mousewheel", (e) => {
//   if (e.deltaY > 0 && video_container.scrollTop + video_container.clientHeight * 1.5 >= video_container.scrollHeight) {
//     document.body.parentElement.scrollTop += e.deltaY / 2
//   }
// })
// // Agregar un evento de scroll a la ventana
// document.addEventListener('scroll', handleScroll, false);

// // Aplicar estilos iniciales
// handleScroll();

// // Text animation in fullscreen scroller
// containers.forEach((root) => {
//   const obs = new IntersectionObserver((entries) => {
//     for (const entry of entries) {
//       if (entry.isIntersecting) {
//         entry.target.classList.add('seen');
//       }
//     }
//   }, {
//     root,
//     threshold: 0.5,
//   });

//   root.querySelectorAll('.vh__video-box').forEach((element) => obs.observe(element));
// });



/*----------------------------------------------------------------------------------------
   Función para abrir y cerrar la página de orders
----------------------------------------------------------------------------------------*/
const btnOrders = document.querySelectorAll(".orders__container .orders__header .btn-nude")
btnOrders.forEach(btn => {
  const misPedidos = document.getElementById("mis-pedidos")
  btn.addEventListener("click", function () {
    const orders = document.querySelector(".orders__container")
    const account = document.querySelector(".main__account")
    account.classList.toggle("hidden")
    orders.classList.toggle("hidden")
  }, false)

  misPedidos.addEventListener("click", function () {
    const orders = document.querySelector(".orders__container")
    const account = document.querySelector(".main__account")
    account.classList.toggle("hidden")
    orders.classList.toggle("hidden")
  }, false)
});

/*--------------------------------------------------------------------
  Funcion SCROLL
--------------------------------------------------------------------*/


/*----------------------------------------------------------------------------------------
   Función ocultar imagen de tech si no se ha subido el archivo
    *esto es para el snippet card-product*

function cleanBrokenTechImages() {
  document.querySelectorAll(".tech-img").forEach(function (img) {
    if (!img.dataset.errorHandled) {
      img.dataset.errorHandled = "true";
      img.addEventListener("error", function () {
        this.remove();
      });
      img.addEventListener("load", function () {
        this.classList.add("loaded");
      });
      if (img.complete) {
        if (img.naturalWidth === 0) {
          img.remove();
        } else {
          img.classList.add("loaded");
        }
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  cleanBrokenTechImages();
  const interval = setInterval(cleanBrokenTechImages, 1000);
  setTimeout(() => clearInterval(interval), 5000);
});
----------------------------------------------------------------------------------------*/
